import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Subscription, subscriptionService } from "src/services/subscriptionService";
import { keys, staleTimes } from "./keys";

/**
 * All subscriptions, for the super-admin table.
 *
 * `dataUpdatedAt` replaces the `getCacheInfo()` readout the page used to show:
 * it is the real time this data was last fetched, rather than a timestamp the
 * service wrote into localStorage alongside the payload.
 */
export const useSubscriptions = () =>
  useQuery<Subscription[]>({
    queryKey: keys.subscriptions.list(),
    staleTime: staleTimes.stats,
    queryFn: () => subscriptionService.getAllSubscriptions(),
  });

/**
 * POST subscriptions/sync — pulls current state from PayFast. The list is stale
 * the moment this succeeds, so invalidate rather than asking callers to refetch.
 */
export const useSyncSubscriptions = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => subscriptionService.syncWithPayfast(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.subscriptions.all });
    },
  });
};
